import React, { Component } from 'react';
import datadogRumClient from '../../utils/datadog-rum';
import { Analytics } from '../../ModularReduxAnalytics';
import css from './ErrorBoundary.module.scss';
import Button from '../UI/Button/index';

interface Props {
  children?: any;
  modularReduxEnabled: boolean;
}

interface State {
  hasError: boolean;
}

// Has to be a class function due to componentDidCatch and getDerivedStateFromError not having hooks yet
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const eventProps = {
      registration_step: 'unexpected_error',
      error_message:
        (error && error.message) ||
        'An unexpected error occurred. Please try again. If the problem continues please call support at 888-483-2645.'
    };
    Analytics.trackEvent('Registration Error Triggered', {
      eventProps
    });
    datadogRumClient.addError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={css.errorBoundary}>
          <p>
            An unexpected error occurred. Please try again. If the problem
            continues please call support at 888-483-2645.
          </p>
          <Button
            text="Try again"
            onClick={() => {
              window.location.href = `https://greenlight.com/`;
            }}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
